import { ApplicationRecord } from './application_record'

ApplicationRecord.sync = true
window.ApplicationRecord = ApplicationRecord

import './asistencia.model'
import './asistencia_alumno.model'
import './anuncio.model'
